import { useState, useMemo, useCallback } from "react";

const fr = {
  appName: "TravelMate",
  tagline: "Ton assistant voyage intelligent",
  inputPlaceholder: "Écris ta réponse...",
  send: "Envoyer",
  activities: "🗺 Activités recommandées",
  hotels: "🏨 Hébergements",
  food: "🍽 Où manger ?",
  resultsTitle: "Ton voyage",
  noResults: "Les recommandations apparaîtront ici une fois la conversation terminée.",
  errorTitle: "Erreur",
  errorMsg: "Une erreur est survenue. Réessayez.",
  exploreAnother: "Explorer une autre destination",
  planMyTrip: "Planifier mon voyage",
  viewResults: "Voir les résultats",
};

const en: typeof fr = {
  appName: "TravelMate",
  tagline: "Your smart travel assistant",
  inputPlaceholder: "Type your answer...",
  send: "Send",
  activities: "🗺 Recommended activities",
  hotels: "🏨 Accommodations",
  food: "🍽 Where to eat?",
  resultsTitle: "Your trip",
  noResults: "Recommendations will appear here once the conversation is complete.",
  errorTitle: "Error",
  errorMsg: "Something went wrong. Please try again.",
  exploreAnother: "Explore another destination",
  planMyTrip: "Plan my trip",
  viewResults: "View results",
};

export type Lang = "fr" | "en";

function getDefaultLang(): Lang {
  const nav = navigator.language || "en";
  return nav.startsWith("fr") ? "fr" : "en";
}

export function useLang() {
  const [lang, setLang] = useState<Lang>(getDefaultLang);

  const toggleLang = useCallback(() => {
    setLang((prev) => (prev === "fr" ? "en" : "fr"));
  }, []);

  const t = lang === "fr" ? fr : en;
  return { lang, t, setLang, toggleLang };
}
